export const areSetsEqual = <T>(first: Set<T>, second: Set<T>): boolean =>
  first.size === second.size && [...first].every(x => second.has(x));
